import { filetypeMapper } from '../types/FileType';
const unitTables = ['PB', 'TB', 'GB', 'MB', 'KB'];
export const displayByte = (size) => {
    let value = size;
    let unit = 'bytes';
    let sizeCheck = [...unitTables];
    while (value > 1024 && sizeCheck.length > 0) {
        value = Number((value / 1024).toFixed(1));
        unit = sizeCheck.pop() || unit;
    }
    return `${value} ${unit}`;
};
const isFixed = (value) => value !== undefined && value !== 'auto';
export const resizeImageByCSS = (intendedSize, originalSize) => {
    const { width, height } = intendedSize;
    // Directly apply strict intended size
    if (isFixed(width) && isFixed(height)) {
        return { width, height };
    }
    // Any one side is fixed, resize the image according to aspect ratio
    const aspectRatio = `${originalSize.width} / ${originalSize.height}`;
    if (isFixed(width)) {
        return {
            width,
            aspectRatio,
        };
    }
    if (isFixed(height)) {
        return {
            height,
            aspectRatio,
        };
    }
    // No intended size given (a special case of no side fixed), fallback to original size
    if (width === undefined && height === undefined)
        return {
            width: originalSize.width,
            height: originalSize.height,
        };
    // Pass through non-fixed size
    return { width, height };
};
export const getFileTypeByName = (filename) => {
    var _a, _b;
    return filetypeMapper[(_b = (_a = filename.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) !== null && _b !== void 0 ? _b : ''];
};
